import { render, staticRenderFns } from "./ErrorTest.vue?vue&type=template&id=379312a8&"
import script from "./ErrorTest.vue?vue&type=script&lang=js&"
export * from "./ErrorTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports